import ProductAdd from './product-add.vue';
import { createApp } from 'vue';

export const productAdd = (element) => {
	const buttons = element.querySelectorAll('.product-add');

	const { id } = element.dataset;
	buttons.forEach((button) => {
		const app = createApp(ProductAdd, { id });
		app.use(window.app.pinia);
		app.mount(button);
	});
};
